import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FindControlIdService {

  readonly AllergyReaction = 'AllergyReaction';
  readonly AppointmentHistoryStatusesToExclude = 'AppointmentHistoryStatusesToExclude';
  readonly FNDHistoryGroup = 'FNDHistoryGroup';
  readonly FacilityPatientProgram = 'FacilityPatientProgram';
  readonly FacilityPortalMessageRouting = 'FacilityPortalMessageRouting';
  readonly FacilityPortalPatient = 'FacilityPortalPatient';
  readonly FacilityServiceSite = 'FacilityServiceSite';
  readonly FindProcedureGroupOnly = 'FindProcedureGroupOnly';
  readonly HealthCareServiceLocation = 'HealthCareServiceLocation';
  readonly InternalProviders = 'InternalProviders';
  readonly ListAddIn = 'ListAddIn';
  readonly ListAmendmentSource = 'ListAmendmentSource';
  readonly ListAppointmentStatus = 'ListAppointmentStatus';
  readonly ListAppointmentType = 'ListAppointmentType';
  readonly ListAttachmentType = 'ListAttachmentType';
  readonly ListCacheMachine = 'ListCacheMachine';
  readonly ListCalendar = 'ListCalendar';
  readonly ListDisease = 'ListDisease';
  readonly ListDocumentLinkingFolderType = 'DocumentLinkingFolderType';
  readonly ListDxTileConfiguration = 'ListDxTileConfiguration';
  readonly ListEduForm = 'ListEduForm';
  readonly ListFilter = 'ListFilterV2';
  readonly ListFindControlBehavior = 'ListFindControlBehavior';
  readonly ListFormattingTemplate = 'ListFormattingTemplate';
  readonly ListGender = 'ListGender';
  readonly ListHistorian = 'ListHistorian';
  readonly ListHistoryGroup = 'ListHistoryGroup';
  readonly ListHxRelationship = 'ListHxRelationship';
  readonly ListImmzCompletion = 'ListImmzCompletion';
  readonly ListImmzContraindication = 'ListImmzContraindication';
  readonly ListImmzEvidenceOfImmunity = 'ListImmzEvidenceOfImmunity';
  readonly ListImmzHistorySource = 'ListImmzHistorySource';
  readonly ListImmzReaction = 'ListImmzReaction';
  readonly ListImmzRefusal = 'ListImmzRefusal';
  readonly ListImmzSpecialIndications = 'ListImmzSpecialIndications';
  readonly ListLaboratory = 'ListLaboratory';
  readonly ListMacroGroup = 'ViewMacroGroupUser_SelectableV2';
  readonly ListMacroGroupByUser = 'ViewMacroGroupUserV2';
  readonly ListMessageSubType = 'ListMessageSubType';
  readonly ListMessageType = 'ListMessageType';
  readonly ListMessageUrgency = 'ListMessageUrgency';
  readonly ListMisc = 'ListMisc';
  readonly ListObservationItem = 'ListObservationItem';
  readonly ListPatientProgram = 'ListPatientProgram';
  readonly ListPrintSet = 'ListPrintSet';
  readonly ListProblemStatus = 'ProblemStatus';
  readonly ListProcedureModifier = 'ListProcedureModifier';
  readonly ListRelationship = 'ListRelationship';
  readonly ListRoom = 'ListRoom';
  readonly ListSecurityGroup = 'ListSecurityGroup';
  readonly ListServiceSite = 'ListServiceSite';
  readonly ListTimeFrame = 'ListTimeFrame';
  readonly ListTimespan = 'ListTimespan';
  readonly ListTypeofVaccine = 'ListTypeofVaccine';
  readonly ListVFCEligibility = 'ListVFCEligibility';
  readonly ListVaccineAdmin = 'ListVaccineAdmin';
  readonly ListVaccineFundingSource = 'ListVaccineFundingSource';
  readonly ListVaccineMfr = 'ListVaccineMfr';
  readonly ListVaccineRoute = 'ListVaccineRoute';
  readonly ListVaccineSite = 'ListVaccineSite';
  readonly ListWeightConditions = 'ListWeightConditions';
  readonly NegationReason = 'NegationReason';
  readonly ObservationDefaultSettings = 'ObservationDefaultSettings';
  readonly PatientProblemDiagnosisHistory = 'PatientProblemDiagnosisHistory';
  readonly ProcedureHistoryStatus = 'ProcedureHistoryStatus';
  readonly ProcedureHistoryTerm = 'ProcedureHistoryTerm';
  readonly ProceduresFiltered = 'ProceduresFiltered';
  readonly ProviderWorklist = 'ProviderWorklist';
  readonly RxProviders = 'RxProviders';
  readonly SO = 'SO';
  readonly SO_DST = 'SO_DST';
  readonly SP = 'SP';
  readonly SP_DST = 'SP_DST';
  readonly TypeOfVaccineFiltered = 'TypeOfVaccineFiltered';
  readonly ViewFNDConfiguration = 'ViewFNDConfigurationV2';
  readonly ViewFindVaccine = 'ViewFindVaccine';
  readonly ViewFindVaccineFiltered = 'ViewFindVaccineFiltered';
  readonly ViewFindVideoAllowedPersonContact = 'ViewFindVideoAllowedPersonContact';
  readonly ViewFindVideoPatientProvider = 'ViewFindVideoPatientProvider';
  readonly ViewHomepageConfiguration = 'ViewHomepageConfiguration';
  readonly ViewProvider = 'ViewProvider';
  readonly ViewProviderSupervisor = 'ViewProviderSupervisor';
  readonly ViewUserAndUserGroup = 'ViewFindUserAndUserGroup';
  readonly ViewUserAndUserGroupAndFacilityPortalGroup = 'ViewFindUserAndUserGroupAndFacilityPortalGroup';
  readonly ViewUserFilters = 'ViewUserFilters';
  readonly WaitingList = 'WaitingList';
  readonly ListUserSetting = 'ListUserSetting';
}
